var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShoplazza(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "300.000000pt",
    height: "282.000000pt",
    viewBox: "0 0 300.000000 282.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,282.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 2784 l-40 -36 0 -1375 0 -1374 160 82 160 81 0 1164 0 1164 1170 0 1170 0 2 -1167 3 -1168 153 -78 c85 -43 160 -76 168 -73 12 5 14 200 14 1328 0 938 -3 1335 -11 1363 -7 24 -29 57 -54 82 l-42 43 -1407 0 -1406 0 -40 -36z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1705 1891 c-46 -21 -79 -54 -94 -94 -13 -33 -16 -1223 -3 -1230 4 -3 79 32 167 76 l160 82 3 422 2 423 323 2 322 3 0 165 0 165 -420 2 c-391 3 -423 1 -460 -16z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoplazza);
export default __webpack_public_path__ + "static/media/shoplazza.6865d95fb0e2a041e6dc7ca76b550eef.svg";
export { ForwardRef as ReactComponent };